export default "__VITE_ASSET__Dl29VYbn__"